:host {
  --background-color: var(--stzh-quote-background-color, #{$colorGrey10});
  --color: var(--stzh-quote-color, #{$colorPrimary70});
  --quotemarks-color: var(--stzh-quote-color, #{$colorSecondary40});
}

.stzh-quote {
  position: relative;
  background-color: var(--background-color);
  @include spaceCurve('padding-top', medium);
  @include spaceCurve('padding-right', medium);
  @include spaceCurve('padding-bottom', medium);
  @include spaceCurve('padding-left', medium);

  @include mq($from: small) {
    padding-left: 87px;
  }

  @include mq($from: medium) {
    padding-left: 158px;
  }

  @media print {
    page-break-inside: avoid;
    break-inside: avoid;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  &__content {
    margin: 0;
  }

  &__text {
    @include fontCurve('h3');
    @include font('heavy');
    margin: 0;
    padding: 0;
    display: flex;
    color: var(--color);

    &::before,
    &::after {
      display: block;
      font-size: var(--stzh-font-mega-font-size);
      color: var(--quotemarks-color);

      @include mq($from: large) {
        font-size: var(--stzh-font-hero-font-size);
      }
    }

    &::before {
      content: '\00AB';
      display: flex;
      align-items: flex-start;
      padding-right: var(--stzh-space-xsmall);
      line-height: 0;
      padding-top: var(--stzh-space-small);
    }

    &::after {
      content: '\00BB';
      display: flex;
      align-items: flex-end;
      padding-left: var(--stzh-space-xsmall);
      line-height: 0;
      padding-bottom: var(--stzh-space-medium);

      @include mq($from: large) {
        padding-bottom: var(--stzh-space-large);
      }
    }
  }

  &__author {
    display: block;
    @include spaceCurve('margin-top', regular);
    color: var(--color);
    @include font('heavy');
    font-size: var(--stzh-font-micro-font-size);
    margin-left: 26px;

    @include mq($from: medium) {
      font-size: var(--stzh-font-milli-font-size);
    }

    @include mq($from: large) {
      margin-left: 33px;
    }

    @include mq($from: ultra) {
      font-size: var(--stzh-font-centi-font-size);
    }
  }
}
